import { render, staticRenderFns } from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=template&id=5a8b5996&scoped=true&"
import script from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=script&lang=js&"
export * from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoTrainPlanDatabaseSub.vue?vue&type=style&index=0&id=5a8b5996&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b5996",
  null
  
)

export default component.exports